// store/reducers/agentsReducer.ts
import {
    FETCH_TOOLS_REQUEST,
    FETCH_TOOLS_SUCCESS,
    FETCH_TOOLS_FAILURE,
} from '../../actions';

const initialState = {
    loading: false,
    tools: [],
    error: null,
};

const toolsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TOOLS_REQUEST:
            return { ...state, loading: true };
        case FETCH_TOOLS_SUCCESS:
            return { ...state, loading: false, tools: action.payload };
        case FETCH_TOOLS_FAILURE:
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
};

export default toolsReducer;
